module.exports = __webpack_public_path__ + "static/img/3-4.ae50f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-4.jpg
// module id = z2G+
// module chunks = 1